import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Model = lazy(() => import('es/app/views/site/models'));
const EditCalpuff = lazy(() => import('es/app/views/site/models/edit/calpuff'));
const EditCalpuffConfigurationForm = lazy(
    () => import('es/app/views/site/models/edit/calpuff/EditCalpuffConfigurationForm')
);
const EditCalmet = lazy(() => import('es/app/views/site/models/edit/calmet'));
const EditCalmetConfigurationForm = lazy(
    () => import('es/app/views/site/models/edit/calmet/EditCalmetConfigurationForm')
);
const EditTrajectory = lazy(() => import('es/app/views/site/models/edit/trajectory'));
const EditTrajectoryConfigurationForm = lazy(
    () => import('es/app/views/site/models/edit/trajectory/EditTrajectoryConfigurationForm')
);
const RunModel = lazy(() => import('es/app/views/site/models/run-model/RunModel'));

export function ModelRoutes() {
    return (
        <Route path={siteMap.models.search()} element={<Model />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={siteMap.models.calpuff().create()} element={<EditCalpuff />}>
                <Route index element={<EditCalpuffConfigurationForm />} />
            </Route>
            <Route path={siteMap.models.calpuff().edit().root} element={<EditCalpuff />}>
                <Route index element={<EditCalpuffConfigurationForm />} />
                <Route path={siteMap.models.calpuff().edit().run} element={<RunModel />} />
            </Route>
            <Route path={siteMap.models.calmet().create()} element={<EditCalmet />}>
                <Route index element={<EditCalmetConfigurationForm />} />
            </Route>
            <Route path={siteMap.models.calmet().edit().root} element={<EditCalmet />}>
                <Route index element={<EditCalmetConfigurationForm />} />
                <Route path={siteMap.models.calmet().edit().run} element={<RunModel />} />
            </Route>
            <Route path={siteMap.models.trajectory().create()} element={<EditTrajectory />}>
                <Route index element={<EditTrajectoryConfigurationForm />} />
            </Route>
            <Route path={siteMap.models.trajectory().edit().root} element={<EditTrajectory />}>
                <Route index element={<EditTrajectoryConfigurationForm />} />
                <Route path={siteMap.models.trajectory().edit().run} element={<RunModel />} />
            </Route>
        </Route>
    );
}
